import { _ as _createClass, a as _classCallCheck } from '../createClass-70c51ca1.js';
import { _ as _defineProperty } from '../defineProperty-377d5a7f.js';

var RequestStore = /*#__PURE__*/function () {
  function RequestStore() {
    _classCallCheck(this, RequestStore);
  }
  _createClass(RequestStore, null, [{
    key: "get",
    value: function get(hash) {
      if (RequestStore.has(hash)) {
        return RequestStore.store.get(hash);
      }
    }
  }, {
    key: "set",
    value: function set(hash, request) {
      if (!RequestStore.has(hash)) {
        RequestStore.store.set(hash, request);
      }
    }
  }, {
    key: "has",
    value: function has(hash) {
      return RequestStore.store.has(hash);
    }
  }, {
    key: "drop",
    value: function drop(hash) {
      if (RequestStore.has(hash)) {
        RequestStore.store["delete"](hash);
      }
    }
  }]);
  return RequestStore;
}();
_defineProperty(RequestStore, "store", new Map());

export { RequestStore as default };
//# sourceMappingURL=index.js.map
